const clamp = (n, min, max) => {
  if (!Number.isFinite(n)) return min;
  return Math.max(min, Math.min(max, n));
};

const toNum = (v, fallback = null) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

export const DEFAULT_TEASER_CONFIG = {
  mode: "full", // full | clip | advanced
  clip: { startSec: 0, endSec: 15 },
  advanced: {
    order: "sequence", // sequence | random
    loop: true,
    allowRepeat: false,
    transition: { type: "none", durationMs: 250 }, // none | fade
    segments: [
      { startSec: 0, endSec: 5 },
      { startSec: 6, endSec: 11 },
    ],
  },
};

const normalizeSegment = (seg) => {
  const startSec = Math.max(0, toNum(seg?.startSec, 0));
  const endCandidate = toNum(seg?.endSec, startSec + 1);
  const endSec = endCandidate > startSec ? endCandidate : startSec + 1;
  return { startSec, endSec };
};

export const normalizeTeaserConfig = (cfg) => {
  const mode = ["full", "clip", "advanced"].includes(cfg?.mode)
    ? cfg.mode
    : DEFAULT_TEASER_CONFIG.mode;

  const clip = normalizeSegment(cfg?.clip || DEFAULT_TEASER_CONFIG.clip);

  const advRaw = cfg?.advanced || {};
  const segmentsRaw = Array.isArray(advRaw.segments)
    ? advRaw.segments
    : DEFAULT_TEASER_CONFIG.advanced.segments;

  const segments = segmentsRaw
    .map(normalizeSegment)
    .filter((s) => s.endSec > s.startSec);

  const transitionType = ["none", "fade"].includes(advRaw?.transition?.type)
    ? advRaw.transition.type
    : DEFAULT_TEASER_CONFIG.advanced.transition.type;

  return {
    mode,
    clip,
    advanced: {
      order: advRaw.order === "random" ? "random" : "sequence",
      loop: advRaw.loop !== false,
      allowRepeat: !!advRaw.allowRepeat,
      transition: {
        type: transitionType,
        durationMs: clamp(toNum(advRaw?.transition?.durationMs, 250), 0, 4000),
      },
      segments,
    },
  };
};

export const parseTeaserConfig = (raw) => {
  if (!raw) return normalizeTeaserConfig(DEFAULT_TEASER_CONFIG);
  try {
    if (typeof raw === "string") return normalizeTeaserConfig(JSON.parse(raw));
    if (typeof raw === "object") return normalizeTeaserConfig(raw);
  } catch {
    return normalizeTeaserConfig(DEFAULT_TEASER_CONFIG);
  }
  return normalizeTeaserConfig(DEFAULT_TEASER_CONFIG);
};

export const serializeTeaserConfig = (cfg) => {
  const normalized = normalizeTeaserConfig(cfg);
  if (normalized.mode === "full") return null;
  return JSON.stringify(normalized);
};
